import { render, staticRenderFns } from "./BicInput.vue?vue&type=template&id=4b736f2d&scoped=true"
import script from "./BicInput.vue?vue&type=script&lang=ts"
export * from "./BicInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b736f2d",
  null
  
)

export default component.exports